var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE2Kitchen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 3.63L3 25.89V69h70V25.9L38 3.63zM69 65H7V28.08L38 8l31 20.08V65zM13 43h44v5a8.07 8.07 0 01-8.06 7.86H33A8.14 8.14 0 0125 48v-1H13a2 2 0 010-4zm18.34-9H39v-4h4v4h7.73c3.46 0 6.27 2.13 6.27 6H25.07c0-3.87 2.81-6 6.27-6z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E2_Kitchen.b6d826c4.svg";
export { SvgE2Kitchen as ReactComponent };